module.exports = __webpack_public_path__ + "img/edge_restauration_cereales.6c099ee3.svg";